import {
  SEND_ASSISTANT_MESSAGE,
  PERFORM_ASSISTANT_ACTION,
  RECORD_PROMPT_USAGE,
  UPDATE_CONVERSATION_TITLE,
} from "./Mutations";
import {
  GET_ASSISTANT_CREATION_OPTIONS,
  GET_ASSISTANT_REQUEST,
  GET_ASSISTANT_ACTIONS,
  GET_SUGGESTED_PROMPTS,
  GET_MY_CONVERSATIONS,
  GET_CONVERSATION,
  GET_ASSISTANT_USAGE_STATS,
} from "./Queries";

export class AssistantClient {
  constructor(client) {
    this.client = client;
  }

  async getCreationOptions(classId) {
    const res = await this.client.query({
      query: GET_ASSISTANT_CREATION_OPTIONS,
      variables: { classId },
      fetchPolicy: "network-only",
    });
    return res.data.assistantCreationOptions;
  }

  async sendMessage({
    message,
    conversationId = null,
    context = null,
    requestId,
    retry = false,
  }) {
    const variables = {
      requestId,
      retry,
      message,
      conversationId,
    };

    if (context && Object.keys(context).length > 0) {
      if (context.creation) variables.creation = context.creation;
      if (context.class_id) {
        variables.classId = context.class_id;
      }
      if (context.assignment_id) {
        variables.assignmentId = context.assignment_id;
      }
    }

    const res = await this.client.mutate({
      mutation: SEND_ASSISTANT_MESSAGE,
      variables,
    });

    const response = res.data.sendAssistantMessage;

    // Parse the data field if it's a JSON string
    if (response.data && typeof response.data === "string") {
      try {
        response.data = JSON.parse(response.data);
      } catch (e) {
        console.error("Failed to parse assistant data:", e);
        response.data = null;
      }
    }

    return response;
  }

  async getActions(conversationId) {
    const res = await this.client.query({
      query: GET_ASSISTANT_ACTIONS,
      variables: { conversationId },
      fetchPolicy: "network-only",
    });
    return res.data.assistantActions;
  }
  async performAction(actionId, operation, revision) {
    const res = await this.client.mutate({
      mutation: PERFORM_ASSISTANT_ACTION,
      variables: { actionId, operation, revision },
    });
    return res.data.performAssistantAction;
  }
  async getRequest(requestId) {
    const res = await this.client.query({
      query: GET_ASSISTANT_REQUEST,
      variables: { requestId },
      fetchPolicy: "network-only",
    });
    return res.data.assistantRequest;
  }

  async recordPromptUsage({ promptText, conversationId, contextData = null }) {
    const variables = {
      promptText,
      conversationId,
    };

    if (contextData) {
      variables.contextData = JSON.stringify(contextData);
    }

    const res = await this.client.mutate({
      mutation: RECORD_PROMPT_USAGE,
      variables,
    });

    return res.data.recordPromptUsage;
  }

  async getSuggestedPrompts(category) {
    const res = await this.client.query({
      query: GET_SUGGESTED_PROMPTS,
      variables: { category },
      fetchPolicy: "cache-first",
    });

    return res.data.suggestedPrompts;
  }

  async getMyConversations({ first = 10, offset = 0 } = {}) {
    const res = await this.client.query({
      query: GET_MY_CONVERSATIONS,
      variables: { first, offset },
      fetchPolicy: "network-only",
    });

    return res.data.myConversations;
  }

  async getConversation(id) {
    const res = await this.client.query({
      query: GET_CONVERSATION,
      variables: { id },
      fetchPolicy: "network-only",
    });

    return res.data.conversation;
  }

  async updateConversationTitle({ conversationId, title }) {
    const res = await this.client.mutate({
      mutation: UPDATE_CONVERSATION_TITLE,
      variables: { conversationId, title },
    });

    return res.data.updateConversationTitle;
  }

  async getUsageStats() {
    const res = await this.client.query({
      query: GET_ASSISTANT_USAGE_STATS,
      fetchPolicy: "network-only",
    });

    return res.data.assistantUsageStats;
  }
}
